import ModelInterface from '@/models/ModelInterface'
import {makeNotification} from '@/services/notifications'
import moment, {Moment} from 'moment'
import store from 'src/store'
import {RawNotification} from '@/types/entity/RawNotification'

declare interface GetDate {
  (momentWrap: true): Moment

  (momentWrap: false): string
}

class Notification extends ModelInterface<RawNotification> {
  /**
   * Notification type
   * @returns {string}
   */
  public getType () {
    return this.data.type
  }

  /**
   * Notification type
   * @returns {string||Moment}
   */
    // @ts-ignore
  public getDate: GetDate = (momentWrap = true) => {
    return momentWrap ? moment(this.data._ct) : this.data._ct
  }

  /**
   * Notification params
   * @returns {Array}
   */
  public getParams () {
    return this.data.params
  }

  /**
   * Notification unread flag
   * @returns {Boolean}
   */
  public isUnread () {
    return !!this.data.unread
  }

  /**
   * Notification mark read
   * @returns {Boolean}
   */
  public async markRead () {
    this.data.unread = false
    store.commit('notifications/readOne')
    await store.dispatch('notifications/markRead', this.getId())
  }

  /**
   * Notification delete
   * @returns {Boolean}
   */
  public async delete () {
    if (this.isUnread()) {
      store.commit('notifications/readOne')
    }
    await store.dispatch('notifications/deleteNotification', this.getId())
  }

  public makeText () {
    return makeNotification(this)
  }
}


export default Notification